module.exports = __webpack_public_path__ + "img/gcp.406edd3f.svg";